export const ROOT = '/';
export const HOME = '/home';
export const CHAT = '/chat';